import { parseUrl, getCleanUrl } from 'js/utils/url.util';
import { languageService } from 'js/services/language.service';

export const getAlternateLinks = ({ page, allowedLocales, defaultLocale }) => {
    if (!page || !allowedLocales) {
        return [];
    }

    const { localeToUrl = {} } = page.layoutDynamicConfig.canonicalTagConfiguration;
    const alternateLinks = [];

    for (const lang of allowedLocales) {
        if (lang in localeToUrl) {
            continue;
        }

        const { getTwoLetterLanguage, aliasLocaleMapping } = languageService;
        const hrefLang = getTwoLetterLanguage(lang);
        const hrefLangUrl = aliasLocaleMapping[lang] || hrefLang;
        const href = `${location.origin}${lang === defaultLocale ? '' : `/${hrefLangUrl}`}${getCleanUrl(location.pathname)}`;

        alternateLinks.push({ href, hrefLang: lang.replace('_', '-') });
    }

    return alternateLinks;
};

export const getCanonicalLinkUrl = ({ page, defaultLocale, lang }) => {
    const { useLayout, layout, customUrl } = page.layoutDynamicConfig.canonicalTagConfiguration;
    const url = (useLayout ? location.origin + layout : customUrl) || location.origin + location.pathname;
    const language = languageService.getTwoLetterLanguage(lang);
    const defaultLanguage = languageService.getTwoLetterLanguage(defaultLocale);
    let linkUrl = new window.URL(url, document.baseURI);

    if (useLayout) {
        const { cleanUrl } = parseUrl(linkUrl.pathname);
        linkUrl = language === defaultLanguage || !language ? `${linkUrl.origin}${cleanUrl}` : `${linkUrl.origin}/${language}${cleanUrl}`;
    }

    return linkUrl;
};

export const getPageStyles = ({ page }) => {
    const {
        customCSS = '',
        layoutDynamicConfig: {
            backgroundConfiguration: {
                backgroundImage,
                backgroundColor,
                backgroundFixed
            }
        }
    } = page;

    const bodyStyles = `body {
        background-image: url("${backgroundImage}");
        ${backgroundColor ? `background-color: ${backgroundColor};` : ''}
        ${backgroundFixed ? 'background-attachment: fixed;' : ''}
    }`;

    return `${bodyStyles} ${customCSS}`;
};

export const getRootClassNames = (rootClassNames) => rootClassNames ? rootClassNames.split(' ').map(className => `root-${className}`) : [];

export const getPageClassNames = (rootClassNames, deviceClassNames = '') => {
    const deviceClassNamesArray = deviceClassNames.split(' ');
    let pageClassNames = Array
        .from(document.documentElement.classList)
        .filter(className => !/^root-/.test(className) && className !== 'portrait' && className !== 'landscape');

    deviceClassNamesArray.forEach((deviceClassName) => {
        pageClassNames = pageClassNames.filter((pageClassName) => pageClassName !== deviceClassName);
    });

    const rootClassNamesArray = getRootClassNames(rootClassNames);

    pageClassNames = [
        ...pageClassNames,
        ...deviceClassNamesArray,
        ...rootClassNamesArray
    ];

    return pageClassNames.join(' ');
};
